// this created a label for the empty select in the datepicker
if(window.jQuery && typeof jQuery.ui !== 'undefined'){
    function datePickerLabel(triggerIn, triggerOut){

        let CheckinLabel = triggerIn.length;
        let CheckoutLabel = triggerOut.length;

        if( CheckinLabel > 0 && CheckoutLabel > 0){

            let numberRandom1 = Math.floor((Math.random() * 5) + 0);
            let numberRandom2 = Math.floor((Math.random() * 10) + 6);


            let valSelect1 = triggerIn.find('.ui-datepicker-month').attr('id', 'ui-datepicker-month' + numberRandom1);
            let valSelect2 = triggerOut.find('.ui-datepicker-month').attr('id', 'ui-datepicker-month' + numberRandom2);

            let valSelectID1 = valSelect1.attr('id');
            let valSelectID2 = valSelect2.attr('id');

            $('.ui-datepicker-title').prepend('<label hidden>select date</label>');

            triggerIn.find('.ui-datepicker-title label').attr('for', valSelectID1);
            triggerOut.find('.ui-datepicker-title label').attr('for', valSelectID2);

        }

    }

    datePickerLabel( $('#CheckIn'), $('#CheckOut'));
    setTimeout(function(){ 
        $( ".hasDatepicker" ).each(function( index ) {
            $(this).attr('autocomplete','off');
        }); 
    }, 3000);
}

/*this function add a class to header when scroll down the page
/* and change the logo by a new file if needed depending of mockup
*/
var firstEntry = false;
function scrollDownAction(topNumber, classHeader) {

    var logoHeader = document.querySelector('.js-scroll-logo img' ) || [];
    var getLogoUrl;
    var getDataLogo;

    if(logoHeader.length !== 0) {
        getLogoUrl = logoHeader.src || [];
        getDataLogo = logoHeader.getAttribute('data-scroll') || [];
    }


    var headerElement = document.querySelector('header' );

    if(!firstEntry) {
        console.log(getDataLogo.length);
        if(getDataLogo.length > 0) {
            window.addEventListener('scroll', function () {

                if( pageYOffset > topNumber ) {
                    headerElement.classList.add( classHeader );
                    logoHeader.src = getDataLogo;
                } else {
                    headerElement.classList.remove( classHeader );
                    logoHeader.src = getLogoUrl;
                }

            });
        } else {
            window.addEventListener('scroll', function () {

                if( pageYOffset > topNumber ) {
                    headerElement.classList.add( classHeader );
                } else {
                    headerElement.classList.remove( classHeader );
                }

            });
        }
        firstEntry = true;
    }
}

/* RESPONSIVE SITES
 ****************************************************************/
if (typeof responsive !== 'undefined') {
    var _responsive = responsive;
}

// Get token stored in session or create new one if not available. The function uses ajax to get the token to be 
// compatible with Page Cache Integration
function _get_form_token(){

    document.querySelectorAll("input[name=_token][type=hidden]").forEach(function(input) {
        input.value = _token;
    });

    // fetch(site_url + '/ajax/functions.php?operation=_get_form_token')
    //     .then(response => {
    //         if (!response.ok) {
    //             throw new Error('Request token failed');
    //         }
    //         return response.text(); 
    //     })
    //     .then(data => {
    //         document.querySelectorAll("input[name=_token][type=hidden]").forEach(function(input) {
    //             input.value = data;
    //         });
    //     })
    //     .catch(error => {
    //         console.error('Error getting token:', error);
    //     });
}

// Function to inspect the GTM script tag and extract Measurement ID
function getMeasurementIDFromScriptTag() {
    var scripts = document.getElementsByTagName('script');
    for (var i = 0; i < scripts.length; i++) {
        var src = scripts[i].src;
        if (src.includes('googletagmanager.com/gtag/js')) {
            var match = src.match(/id=G-[A-Z0-9]+/);
            if (match) {
                console.log('GA4 Measurement ID:', match[0].split('=')[1]);
                return match[0].split('=')[1];
            }
        }
    }
    console.log('No GA4 Measurement ID found in script tags.');
    return null;
}

function generateLinkerParam(callback) {
    // gtag command to generate the linker parameter
    gtag('get', getMeasurementIDFromScriptTag(), 'linker', function(linker) {
      callback(linker);
    });
}

// Decorate links using GA4
function decorateUrlGA4(bookingURL) { 
        
    //Split main url form parameters
    const [baseURL, queryParams] = bookingURL.split("?"); 

    //Create fake button
    const anchor = document.createElement('a');
    anchor.id = 'fakebtn';
    anchor.href = baseURL;
    document.body.appendChild(anchor);

    //Click on fake link to retrieve _gl
    anchor.dispatchEvent(clickEvent);
    const url = new URL(anchor.href);
    const glParam = url.searchParams.get('_gl');

    // Clean up by removing the temporary element
    anchor.remove();

    return baseURL+"?"+queryParams+"&_gl="+glParam;
}

let clickEvent = new MouseEvent("mousedown", {
    bubbles: true,
    cancelable: true,
    view: window
});


function decorateUrlGA4New(url) {
    const urlObj = new URL(url);
    const baseURL = urlObj.origin + urlObj.pathname; // Extract the base URL
    const params = new URLSearchParams(urlObj.search); // Extract query parameters

    // Create the form element
    const form = document.createElement("form");
    form.method = "GET"; // or "POST" depending on your requirement
    form.target = "_blank"; // or "POST" depending on your requirement
    form.action = baseURL;

    // Loop through each query parameter and create hidden input fields
    params.forEach((value, key) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = key;
        input.value = value;
        form.appendChild(input);
    });

    // Append the form to the body (or any other desired container)
    document.body.appendChild(form);
    form.submit();
    form.remove();
}

//Decorate links using GA4 - DEPRECATED
function decorateUrlGA4Deprecated(urlString) {
    // Function to get the cookie value
    var getCookiebyName = function(name) {
        var match = document.cookie.match(new RegExp(name + '=([^;]+)'));
        return match ? match[1].match(/GA1\.[0-9]\.(.+)/)[1] : undefined;
    };

    // Get the values from cookies
    var cookies = {
        _ga: getCookiebyName("_ga"),
        _gid: getCookiebyName("_gid")
    };

    // Generate a simple browser fingerprint based on basic properties
    var browserFingerprint = [
        navigator.userAgent,
        (new Date()).getTimezoneOffset(),
        navigator.language || navigator.userLanguage,
    ].join('*').hashCode();  // Optional: hashCode() can be implemented for simplicity

    // Hash cookie values (simple Base64 encoding)
    var hash_cookie_value = function(val) {
        return val ? btoa(String(val)) : "";
    };

    // Generate linker parameter
    var linkerParam = [
        "1", 
        browserFingerprint, 
        "_ga", 
        hash_cookie_value(cookies._ga), 
        "_gid", 
        hash_cookie_value(cookies._gid)
    ].join('*');

    // Append _gl to the URL
    var url = new URL(urlString);
    url.searchParams.append('_gl', linkerParam);

    return url.toString();
}

// Optional: Hash function for browser fingerprint (if using hashCode approach)
String.prototype.hashCode = function() {
    var hash = 0, i, chr;
    for (i = 0; i < this.length; i++) {
        chr = this.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash.toString(36);
};

window.addEventListener("load", function() {
    let redirecting = false;

    window.addEventListener('resize', function () {
        if (window.innerWidth < 768 && !redirecting && !_responsive) {
          document.cookie = 'forceMobile=1; path=/';
          redirecting = true;
          console.log('redirecting...');
          window.location = window.location;
        }
    });

    /*ON SCROLL CONTENT ANIMATION*/
    if (typeof ScrollMagic !== 'undefined') {
        setTimeout(function () {
          let controller = new ScrollMagic.Controller();
      
          let elements = document.querySelectorAll('.animate-fade');
      
          if (elements.length > 0) {
            elements.forEach(function (element) {
              // build a scene
              let ourScene = new ScrollMagic.Scene({
                triggerElement: element.children[0],
                triggerHook: 0.9,
                reverse: false
              })
                .setClassToggle(element, 'fade-in')
                .addTo(controller);
            });
          }
        }, 500);
    }

    // Get Token and populate on all required forms 
    _get_form_token()

    //Accessibility: Add hidden copy to external link
    setTimeout(() => {
        document.querySelectorAll('a[target="_blank"]').forEach(function(anchor) {
            const sup = document.createElement('sup');
            sup.textContent = ' (opens in new window)';
            sup.classList.add('hidden');
            anchor.appendChild(sup);
        });
    }, "1000");

    //Script lazy load
    const load = () => {
        document.querySelectorAll("script[data-type='lazy']").forEach(el => el.setAttribute("src", el.getAttribute("data-src")));
    }
    const timer = setTimeout(load, 5000);
    const trigger = () => {
        load();
        clearTimeout(timer);
    }
    const events = ["mouseover","keydown","touchmove","touchstart"];
    events.forEach(e => window.addEventListener(e, trigger, {passive: true, once: true}));
}); 
if(window.jQuery) {

    window.addEventListener("load", function() {
        
        /*FANCY BOX*/
        if(typeof $.fancybox == 'function') {
            $(".fancybox").fancybox({
                'padding': 0,
                beforeShow: function () {
                    let imgAlt = $(this.element).find("img").attr("alt");
                    let dataAlt = $(this.element).data("alt");
                    if (imgAlt) {
                        $(".fancybox-image").attr("alt", imgAlt);
                    } else if (dataAlt) {
                        $(".fancybox-image").attr("alt", dataAlt);
                    }
                },
                afterLoad: function(current, previous) {
                    $('html').addClass('fancybox-lock');
                },
                afterClose: function(){
                    $('html').removeClass('fancybox-lock');
                }
            });
            $(".fancybox_iframe").fancybox({
                'type': 'iframe',
                'scrolling': 'no',
                'titleShow': false,
                'padding': 0
            });
            $(".fancybox_inline").fancybox({
                'type': 'inline',
                'scrolling': 'no',
                'titleShow': false,
                'padding': 0
            });
            $(".fancybox_youtube").click(function () {
                $.fancybox({
                    'padding': 0,
                    'autoScale': false,
                    'transitionIn': 'none',
                    'transitionOut': 'none',
                    'title': this.title,
                    'width': 680,
                    'height': 495,
                    'href': this.href.replace(new RegExp("watch\\?v=", "i"), 'v/'),
                    'type': 'swf',
                    'swf': {
                        'wmode': 'transparent',
                        'allowfullscreen': 'true'
                    }
                });

                return false;
            });
        }

        /*EASY SCROLL*/
        $('.scroll').click(function () {
            let target = $(this).attr("href");
            $('html, body').animate({scrollTop: $(target).offset().top - $('header').height()}, 1000);
            return false;
        });

        /*DATE PICKER*/
        if( typeof jQuery.ui !== 'undefined' ) {
            $('.datepicker').datepicker();
        }

        /*Capture all booking form submissions and save its value in the database
        *****************************************************************/
        if( typeof jQuery.ui !== 'undefined'){
            $("#booking-form, #booking-form2").submit(function () {
                const formId = '#'+$(this).attr('id');
            
            let dates = [];
            let data = {};
            $(".hasDatepicker", $(formId)).each(function (i, e) {
                let value = $(e).val();
                dates.push(value);
            });

            data.operation = 'process_checkout';
            data.checkin = dates[0];
            data.checkout = dates[1];
            data.device = 'D';
            data.raw = $(formId).serialize();

            $.post(site_url + 'ajax/functions.php', data, function (resp) {
            }, 'json');

            });
        }

    });
}
